import Vue from 'vue'
import Vuex from 'vuex'

import requestApi from './modules/requestApi'
import auth from './modules/auth'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        requestApi,
        auth
    },
    plugins: [createPersistedState({
        key: 'TodoApp',
        paths: ['auth.live_access_token'],
        // storage: window.sessionStorage
    })]
})

export default store